"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _BriefBlock = _interopRequireDefault(require("../../BriefBlock"));

require("../styles/_creative-input-section.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var CREATIVE_INPUT_INDEX_MAP = ['EXACT', 'BRIEF', 'FULL'];

function onSelectCreativeInput(onChangeField, onBlurField) {
  return function (index) {
    onChangeField(CREATIVE_INPUT_INDEX_MAP[index]);
    onBlurField();
  };
}

function CreativeInputSection(_ref) {
  var onChangeField = _ref.onChangeField,
      creativeInput = _ref.creativeInput,
      canUpdateVideo = _ref.canUpdateVideo,
      onBlurField = _ref.onBlurField;
  var initialValue = CREATIVE_INPUT_INDEX_MAP.findIndex(function (creativity) {
    return creativity === creativeInput;
  });
  return /*#__PURE__*/_react.default.createElement(_BriefBlock.default, {
    title: "Select the level of creative input you want from your Video Editor"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "creative-input-section"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Slider, {
    labels: ['Low', 'Medium', 'High'],
    min: 0,
    max: 2,
    onChange: onSelectCreativeInput(onChangeField('creativeInput'), onBlurField),
    disabled: !canUpdateVideo,
    initialValue: initialValue >= 0 ? initialValue : 0
  })));
}

var _default = /*#__PURE__*/(0, _react.memo)(CreativeInputSection);

exports.default = _default;